<template>
    <modal
        id="finance-transaction-confirm-modal"
        v-model="showModal"
        :title="$t('confirm')"
        :btn-label="$t('confirm')"
        :loading="loading"
        :scrollable="false"
        @submit="submitData"
    >
        <form
            ref="form"
            @submit.prevent="submitData"
        >
            <div class="row">
                <div class="col-md-12">
                    <app-form-group
                        type="textarea"
                        :label="$t('remark')"
                        :placeholder="$textAreaPlaceHolder('remark')"
                        v-model="formData.remark"
                        :text-area-rows="7"
                        :error-message="$errorMessage(errors, 'remark')"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import {TENANT_BASE_URL} from "../../../../common/Config/UrlHelper";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";

export default {
    name: "TransactionConfirmModal",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        transactionId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            formData: {
                remark: "",
            },
        };
    },
    methods: {
        submitData() {
            const url = `${TENANT_BASE_URL}app/finance-transactions/${this.transactionId}/confirm`;
            this.submitFromFixin("post", url, this.formData);
        },
        afterSuccess({data}) {
            this.showModal = false;
            $('#finance-transaction-confirm-modal').modal('hide');
            this.$toastr.s(data.message);
        },
        afterError(response) {
            this.errors = response.data.errors || {};
            this.$toastr.e(response.data.message || this.$t("something_went_wrong"));
        },
    },
};
</script>
